import { AbstractReportPmsApiService } from '../abstract-report.service';
import { ChannelProduction } from '../../../models/reports/production/channel-production.model';

/**
 * @class ChannelProductionReportPmsApiService
 * @extends {AbstractReportPmsApiService<ReservationByRatePlan>}
 */
export class ChannelProductionReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/production/channel-production';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ChannelProduction}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ChannelProduction(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/production/channel-production.service.js